import { QueryClient, MutationCache } from 'react-query';
import { handleMutationError } from './mutationErrorHandler';

/**
 * App-wide react-query client. The MutationCache.onError backstop guarantees
 * every failed mutation surfaces to the operator + Sentry (see
 * `mutationErrorHandler`); mutations carrying a `mutationKey` get tailored copy.
 * This is the safety net that stops an optimistic on/off toggle from silently
 * showing OFF when the request fails or never reaches the backend.
 */
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) =>
      handleMutationError(error, mutation.options.mutationKey)
  })
});
